/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import {
	productDescriptionTitleSX,
	productDescriptionTextSX,
} from '@/components/blocks/ProductDetails/styles/productDescriptionDetails';
import { useLocalization } from '@/data/Localization';
import { ProductType } from '@/data/types/Product';
import { getProductDisplayInfo } from '@/utils/getProductDisplayInfo';
import { Box, Typography, Stack } from '@mui/material';
import React, { FC } from 'react';
import { parseHTML } from '@/utils/parseHTML';

interface BundleDescriptionDetailsProps {
	product?: ProductType;
}

export const BundleDescriptionDetails: FC<BundleDescriptionDetailsProps> = ({ product }) => {
	const localization = useLocalization('productDetail');
	const {
		tabsData: { longDescription },
	} = getProductDisplayInfo(product, product);

	const cleanHTML = longDescription.replace(/<p[^>]*>(\s|&nbsp;|<br>)*<\/p>/g, '');

	return !product ? null : (
		<Stack>
			<Stack sx={{ marginTop: { xs: '0px', md: '21px' }, mr: { xs: 0, md: '40px' } }}>
				<Box display={'flex'} gap={'5px'} alignItems={'center'}>
					<Typography
						component={'h6'}
						sx={{ fontSize: 'var(--font-size-caption)', color: '#929292' }}
					>
						{`Modelo: ${product.partNumber}`}
					</Typography>
				</Box>
				<Typography component={'h2'} sx={productDescriptionTitleSX}>
					{localization.Description.t()}
				</Typography>
				<Typography sx={productDescriptionTextSX}>{parseHTML(cleanHTML)}</Typography>
			</Stack>
		</Stack>
	);
};
